import * as yup from "yup";
import React, { useRef } from "react";
import { AnyObjectSchema } from "yup";
import Lazy from "yup/lib/Lazy";
import { Constants } from "../../helpers/Constants";
import useData from "../../hooks/useData";
import { ApplicationInspection } from "../Components/Home/ApplicationDetails.types";
import { useLocation } from "react-router-dom";


export type SubmitInspectionFormProps = {
  id?: string;
  returnPath?: string;
  title?: string;
 // schema: AnyObjectSchema | Lazy<any, unknown>;
  values?: SubimtInspectionInput;
  action?: "post" | "put";
};
export type FileEntryInput = {
  file: FileList;
};
export interface JsonData {
  name: string;
  value: string;
}

export type ProviderData = {
  id: number;
  name: string;

};


export type SubimtInspectionInput = {
    applicationInspectionId:number
    applicationId:number;
    submitInspectionId: number;
    inspectionFileName: string;
    inspectionFilePath:string;
    engineerSealedCertificate:string;
    engineerSealedCertificatePath:string;
    providerId:number;
    inspectionApprovedDate?:Date;
    isApproved: boolean;
    additionalComments : string;
    additionalInspectionRequired: boolean;
    penaltyOfLawCheck:boolean;
    dateCreated: Date;
    createdBy: string;
    dateUpdated: Date;
    updatedBy: string;
    inspectionStatusId: number;
    userId: number;
    ehdinspectionNumber?: string;

};


export const schema =(permitDate?:string) => yup.object().shape({
  
  // inspectionFileName: yup
  //   .string()
  //   .min(1, "Inspection file is required")
  //   .required("Inspection file is required")
  //   .typeError("Inspection file is required"),
  //   engineerSealedCertificate: yup.string()
  //   .min(1, "EngineerSealed Certificate file is required")
  //   .required("EngineerSealed Certificate file is required")
  //   .typeError("EngineerSealed Certificate file is required"),
    
    providerId: yup
    .string()
    .min(1, "Provider Name is required")
    .required("Provider Name is required")
    .typeError("Provider Name is required"),
    inspectionApprovedDate: yup 
    .date()
    .max(new Date(),"Future Dates are not allowed")
    .min(new Date(getDate(permitDate)),"Inspection Date should be greater than or equal to Permit Date")
        .required("Inspection Date is required")
        .typeError("Inspection Date is required")
    ,
    
    penaltyOfLawCheck: yup
    .boolean()
    .required("PenaltyOfLawCheck is required")
    .typeError("PenaltyOfLawCheck is required")
   
  
});
 const getDate =(input:any)=>{
  if(input === null || input === undefined){
    return new Date();
  }
  
  return new Date(input);
}
